import React from "react";
import { Map, Marker, ZoomControl } from "pigeon-maps";
import { FaCheck, FaEdit, FaTimes } from "react-icons/fa";
import { osm } from "pigeon-maps/providers";

const MapItem = (props) => {
  const color = "#34495E";
  return (
    <div className="mapItem">
      <Map
        provider={osm}
        height={props.height}
        zoomSnap={true}
        center={props.defaultCenter}
        zoom={props.zoom}
        dprs={[1, 2]}
        onClick={(e) => props.setMarkerHandler(e)}
      >
        <Marker width={30} anchor={props.anchor} color={color} />
        <ZoomControl />
      </Map>
      <span className="deleteMap" onClick={() => props.deleteMapHandler(props.mapId)}>
        <FaTimes />
      </span>
      <span className="editMap" onClick={() => props.editMapHandler(props.mapId)}>
        <FaEdit />
      </span>
      <span
        className={props.active ? "activeMap active" : "activeMap"}
        onClick={() => props.activeMapHandler(props.mapId)}
      >
        <FaCheck />
      </span>
      {props.address && <span className="mapAddress">{props.address}</span>}
    </div>
  );
};

export default React.memo(MapItem);
